<template>
  <div class="box">
    <nav-bar :title="$route.meta.title"></nav-bar>
    <div class="top_box_bg"></div>
    <div class="top_box">
      <div class="price_text"><span>¥</span>{{ payMoney }}</div>
      <div class="need_text">应付金额</div>
      <div class="pay_time">
        <img
          class="time_img"
          src="@/assets/home/product_detail/time_icon.png"
        />
        <div class="time_text">支付剩余时间：</div>
        <van-count-down class="time" :time="time" format="HH 时 mm 分 ss 秒" />
      </div>
    </div>
    <div class="pay_info">
      <div class="pay_info_item" v-for="(item, index) in dataList" :key="index">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>
    <pay @selectPayType="selectPayType"></pay>
    <div class="payBtn" @click="pay">立即支付 ¥{{ payMoney }}</div>
  </div>
</template>

<script>
import navBar from "@/components/nav-bar.vue";
import pay from "../../../components/pay.vue";
export default {
  components: {
    navBar,
    pay,
  },
  data() {
    return {
      payMoney: 0.0,
      dataList: [
        { label: "产品详情", value: "九江庐山西海千岛湖" },
        { label: "时间", value: "2011-11-01 下午" },
        { label: "数量", value: "1人" },
        { label: "费用明细", value: "¥150.00" },
        { label: "优惠", value: "¥20" },
        { label: "支付价格", value: "内容信息显示" },
      ],
      // allPrice: "130.00",
      time: 0,
    };
  },
  methods: {
    selectPayType(index) {
      console.log(index);
    },
    pay() {
      console.log("支付");
    },
  },
  mounted() {
    console.log(this.$route.query);
    var params = this.$route.query;
    this.payMoney = params.shouldPay;
    this.dataList = params.dataList;
    this.time = parseInt(params.orderCancelTime) * 60 * 1000;
    /*this.dataList = [
      { label: "产品详情", value: params.title },
      { label: "时间", value: params.placeOrderTime },
      { label: "数量", value: params.num },
      { label: "费用明细", value: "¥" + params.shouldPay },
      { label: "优惠", value: "¥" + params.coupon },
      { label: "支付价格", value: "内容信息显示" },
    ];*/
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f4f6f9;
  padding-bottom: vw(120);
  .top_box_bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: vw(600);
    background: linear-gradient(to top, #f4f6f9, #4684ff, #3377ff);
  }
  .top_box {
    position: relative;
    margin-top: vw(196);
    margin-left: vw(20);
    margin-right: vw(20);
    padding-bottom: vw(40);
    background-color: #ffffff;
    border-radius: vw(12);
    display: flex;
    flex-direction: column;
    align-items: center;
    .price_text {
      margin-top: vw(40);
      color: #3377ff;
      font-size: vw(40);
      span {
        font-size: vw(26);
        margin-top: vw(10);
      }
    }
    .need_text {
      margin-top: vw(11);
      color: #3377ff;
      font-size: vw(26);
    }
    .pay_time {
      margin-top: vw(30);
      display: flex;
      flex-direction: row;
      align-items: center;
      .time_img {
        width: vw(26);
        height: vw(26);
      }
      .time_text {
        margin-left: vw(16);
        color: #5c5f66;
        font-size: vw(26);
      }
      .time {
        color: #5c5f66;
        font-size: vw(26);
      }
    }
  }
  .pay_info {
    position: relative;
    margin-left: vw(20);
    margin-right: vw(20);
    margin-top: vw(20);
    padding-top: vw(10);
    padding-bottom: vw(10);
    background-color: #ffffff;
    border-radius: vw(12);

    .pay_info_item {
      padding-top: vw(20);
      padding-bottom: vw(20);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: vw(28);
      .label {
        margin-left: vw(32);
        color: #999999;
      }
      .value {
        margin-right: vw(32);
        color: #333333;
      }
    }
  }
  .payBtn {
    background-color: #3377ff;
    font-size: vw(30);
    font-weight: bold;
    color: #ffffff;
    margin-top: vw(30);
    margin-left: vw(30);
    margin-right: vw(30);
    height: vw(88);
    line-height: vw(88);
    border-radius: vw(8);
    text-align: center;
  }
}
</style>
